import {
    Autocomplete,
    Box,
    Button,
    InputAdornment,
    TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { REACT_APP_BACKEND_URL } from "../../Utils/Language/urlBase";
import useAuthHeader from "react-auth-kit/hooks/useAuthHeader";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import AddOtherPartyDialog from "../../Components/Dialogs/AddOtherPartyDialog";

const CustomerSelect = () => {
    const authHeader = useAuthHeader();
    const [customers, setCustomers] = useState([]);
    let [searchParams, setSearchParams] = useSearchParams();
    const [isRefresh, setIsRefresh] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [isAddCustomerDialogOpen, setIsAddCustomerDialogOpen] =
        useState(false);

    const navigate = useNavigate();
    useEffect(() => {
        const getCustomers = async () => {
            const response = await fetch(
                `${REACT_APP_BACKEND_URL}/otherparty`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authHeader,
                    },
                }
            );
            const data = await response.json();
            const otherParties = data.otherParties;
            otherParties.push({
                id: 51362,
                name: "Add Customer",
            });
            setCustomers(
                otherParties.map((customer) => ({
                    label: customer.name,
                    value: customer.id,
                }))
            );
        };
        getCustomers();
    }, [authHeader, isRefresh]);

    return (
        <Box>
            {authHeader && isAddCustomerDialogOpen && (
                <AddOtherPartyDialog
                    isOpen={isAddCustomerDialogOpen}
                    onClose={() => {
                        setIsRefresh(!isRefresh);
                        setIsAddCustomerDialogOpen(false);
                    }}
                    authHeader={authHeader}
                />
            )}
            {customers?.length > 0 && (
                <Autocomplete
                    disablePortal
                    id="customer-select"
                    value={selectedCustomer}
                    onChange={(event, newValue) => {
                        if (newValue.value === 51362) {
                            setIsAddCustomerDialogOpen(true);
                        } else {
                            setSelectedCustomer(newValue.value);
                        }
                    }}
                    options={customers}
                    getOptionLabel={(option) => option.label}
                    renderInput={(params) => (
                        <TextField {...params} label="Customer" />
                    )}
                />
            )}
            <Button
                variant="contained"
                sx={{ mt: "10px" }}
                onClick={() =>
                    navigate(
                        `/AddInvoice?invoiceType=${searchParams.get(
                            "invoiceType"
                        )}&selectedCustomer=${selectedCustomer}`
                    )
                }
                disabled={!!!selectedCustomer}
            >
                Next
            </Button>
        </Box>
    );
};

export default CustomerSelect;
